import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {AUTH} from '../constants';
import {EXPIRY_KEY, ID_TOKEN_KEY, REFRESH_TOKEN_KEY, TOKEN_KEY} from '../../utils/define';
import {Post, Put} from '../../utils/httpProvider';
import {checkExpToken} from '../../utils/helper';
import {AUTH_API, ACCOUNT_API, BaseGatewayAuth, BaseGatewayImage} from '../../utils/apiUrl.js';
import { userManager } from '@app/utils/oidc';

//  Action này sử dụng để call API
// export const loginUser = createAsyncThunk(
//     AUTH.LOGIN_THUNK,
//     async (model, {rejectWithValue, fulfillWithValue}) => {
//         const res = await Post(
//             AUTH_API.LOGIN_API,
//             null,
//             {
//                 grant_type: 'password',
//                 username: model.username,
//                 password: model.password,
//                 scope: 'openid profile roles offline_access webapi.access',
//                 client_id: 'WebApiId1992',               // <-- thêm client_id
//                 client_secret: 'WebApiSecret1992',       // <-- thêm client_secret
//                 // comment cái này, test lại
//                 // resource:      BaseGatewayImage
//             },
//             true
//         );

//         if (res.status === 200) {
//             const json = await res.json();
//             console.log(json);
//             return fulfillWithValue(json);
//         }
//         return rejectWithValue(await res.json());
//     }
// );
// export const refreshTokenFunc = createAsyncThunk(
//     AUTH.REFRESH_TOKEN,
//     async (model, {rejectWithValue, fulfillWithValue}) => {
//         // const {auth} = getState();
//         const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);

//         const res = await Post(
//             AUTH_API.REFRESHTOKEN_API,
//             null,
//             {
//                 grant_type: 'refresh_token',
//                 refresh_token: refreshToken,
//                 client_id: 'WebApiId1992',               // <-- thêm client_id
//                 client_secret: 'WebApiSecret1992',       // <-- thêm client_secret
//             },
//             true
//         );

//         if (res.status === 200) {
//             const json = await res.json();
//             return fulfillWithValue(json);
//         }
//         return rejectWithValue(await res.json());
//     }
// );
export const changePasswordAction = createAsyncThunk(
    AUTH.CHANGE_PASSWORD,
    async (model, { rejectWithValue }) => {
        try {
            const response = await Put(ACCOUNT_API.CHANGE_PASSWORD_API, null, model);
            if (response.ok) {
                return { success: true };
            }
            try {
                const data = await response.json();
                return data;
            } catch (e) {
                return { success: false, message: 'Đổi mật khẩu không thành công.' };
            }
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

const initialState = {
    // isLoggedIn: !!localStorage.getItem(TOKEN_KEY),
    isLoggedIn: false,
    token: null,
    errorLogin: null
};

export const authSlice = createSlice({
    name: AUTH.NAME_SLICE,
    initialState,
    reducers: {
        loginSuccess(state, {payload}) {
            localStorage.setItem(EXPIRY_KEY, payload.expiresAt);
            state.isLoggedIn = true;
            state.error      = null;
        },
        logoutUser(state) {
            localStorage.removeItem(EXPIRY_KEY);
            // console.log('post_logout_redirect_uri:', userManager._settings._post_logout_redirect_uri);
            // console.log('post_logout_redirect_uri:', userManager.settings.post_logout_redirect_uri);
            // userManager.signoutRedirect();
            userManager.removeUser();
            window.location.href = `${BaseGatewayAuth}/connect/logout?post_logout_redirect_uri=${encodeURIComponent(window.location.origin + "/")}`;
            state.isLoggedIn = false;
            state.error      = null;
        },
        loginError(state, { payload }) {
            localStorage.removeItem(EXPIRY_KEY);
            state.error = payload;
        }
    },
    // extraReducers: (builder) => {
    //     builder
    //         .addCase(loginUser.fulfilled, (state, {payload}) => {
    //             const {access_token, id_token, refresh_token, expires_in} = payload;
    //             localStorage.setItem(TOKEN_KEY, access_token);
    //             localStorage.setItem(ID_TOKEN_KEY, id_token);
    //             localStorage.setItem(REFRESH_TOKEN_KEY, refresh_token);

    //             const expiryTime = Date.now() + expires_in * 1000;
    //             localStorage.setItem(EXPIRY_KEY, expiryTime);

    //             state.isLoggedIn = true;
    //             state.token = access_token;
    //             state.errorLogin = null;
    //         })
    //         .addCase(loginUser.rejected, (state, action) => {
    //             //  xử lý khi call API bị lỗi
    //             state.isLoggedIn = false;
    //             state.errorLogin =
    //                 action.payload.errors && action.payload.errors.content[0]
    //                     ? action.payload.errors.content[0]
    //                     : null;
    //             state.token = null;
    //         })
    //         .addCase(refreshTokenFunc.fulfilled, (state, {payload}) => {
    //             const {access_token, id_token, refresh_token, expires_in} = payload;
    //             localStorage.setItem(TOKEN_KEY, access_token);
    //             localStorage.setItem(ID_TOKEN_KEY, id_token);
    //             localStorage.setItem(REFRESH_TOKEN_KEY, refresh_token);

    //             const expiryTime = Date.now() + expires_in * 1000;
    //             localStorage.setItem(EXPIRY_KEY, expiryTime);

    //             state.isLoggedIn = true;
    //             state.token = access_token;
    //             state.errorLogin = null;
    //         })
    //         .addCase(refreshTokenFunc.rejected, (state, action) => {
    //             state.isLoggedIn = false;
    //             state.errorLogin =
    //                 action.payload &&
    //                 action.payload.errors &&
    //                 action.payload.errors.content[0]
    //                     ? action.payload.errors.content[0]
    //                     : null;
    //             state.token = null;
    //             localStorage.removeItem(TOKEN_KEY);
    //             localStorage.removeItem(ID_TOKEN_KEY);
    //             localStorage.removeItem(REFRESH_TOKEN_KEY);
    //             localStorage.removeItem(EXPIRY_KEY);
    //             // localStorage.removeItem(TOKEN_KEY);
    //             // localStorage.removeItem(REFRESH_TOKEN_KEY);
    //             // window.location.href = 'http://10.0.0.62:8888/login';
    //             const history = action && action.meta && action.meta.extra ? action.meta.extra.history : null;
    //             if (history) {
    //                 history.push('/login');
    //             } else {
    //                 window.location.href = 'http://localhost:3000/login';
    //             }
    //         });
    // }
});

export const {loginSuccess, logoutUser, loginError } = authSlice.actions;

export default authSlice.reducer;
